import { render, staticRenderFns } from "./AddGymAscentBtn.vue?vue&type=template&id=448380c5"
import script from "./AddGymAscentBtn.vue?vue&type=script&lang=js"
export * from "./AddGymAscentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports